import { render, staticRenderFns } from "./list_item.vue?vue&type=template&id=28c1319a&scoped=true&"
import script from "./list_item.vue?vue&type=script&lang=js&"
export * from "./list_item.vue?vue&type=script&lang=js&"
import style0 from "./list_item.vue?vue&type=style&index=0&id=28c1319a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c1319a",
  null
  
)

export default component.exports